export default __webpack_public_path__ + "static/media/Plant-book.4ecd55bc.png";